import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from '@medflex/i18n';
import { contact as getFullNameWithTitle } from '@medflex/utils/getFullNameWithTitle';
import PropTypes from 'prop-types';
import UserInfo from '../UserInfo';

const PatientMessage = props => {
  const { message, PatientMessageAction = () => '' } = props;
  const { isSender, patient } = message;
  const initials = `${patient.firstName[0]}${patient.lastName[0]}`;
  const title = getFullNameWithTitle({
    firstName: patient.firstName,
    lastName: patient.lastName,
  });
  const { t } = useTranslation('components');

  return (
    <>
      <div className="italic mb-3 text-slate-500">
        {t('ChatMessageStream.patient_message.headline')}
      </div>
      <UserInfo
        avatarInitials={initials}
        title={title}
        titleCn="text-wrap"
        avatarSize="10"
        subtitle={patient.dateOfBirth && `*${format(patient.dateOfBirth, 'DD.MM.YYYY')}`}
      />
      {!isSender && (
        <div className="mt-2">
          <PatientMessageAction message={message} />
        </div>
      )}
    </>
  );
};

PatientMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['patient']),
    time: PropTypes.string.isRequired,
    isSender: PropTypes.bool,
    patient: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      dateOfBirth: PropTypes.string,
    }).isRequired,
  }),
  PatientMessageAction: PropTypes.func.isRequired,
};

export default PatientMessage;
